var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2698 0H2.45396C1.10428 0 0.0122701 1.22911 0.0122701 2.73136L0 24.5822C0 26.0845 1.09201 27.3136 2.44169 27.3136H17.1777C18.5274 27.3136 19.6317 26.0845 19.6317 24.5822V8.19408L12.2698 0ZM14.7237 21.8509H4.90791V19.1195H14.7237V21.8509ZM14.7237 16.3882H4.90791V13.6568H14.7237V16.3882ZM11.0428 9.55976V2.04852L17.7912 9.55976H11.0428Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportDoc);
export default __webpack_public_path__ + "static/media/supportDoc.bc84cf9db1fe4a62a4749b62e28c67aa.svg";
export { ForwardRef as ReactComponent };